import { IPaymentTracking } from "../../../interfaces/paymentTracking";
import ChatList from "../ChatList";
import { Link } from "react-router-dom";
import { useChatList } from "../../../store/ChatList";
import { ContainerCard } from "./index.style";

interface Props {
  listBookings: IPaymentTracking[];
}

const ListCustomer = (props: Props) => {
  const { chats } = useChatList();
  return (
    <ContainerCard>
      {props.listBookings.map((item) => {
        const chat = chats.find((b) => b.uid === item.uid) as any;
        return (
          <Link
            to={{
              pathname: `/chat/${item.bookingId}`,
              state: {
                item,
              },
            }}
            key={item.bookingId}
            style={{ textDecoration: "none" }}
          >
            <ChatList
              {...item}
              pet={item.pets?.find((p) => p.pid === item.pid)}
              isRead={chat?.isRead !== undefined ? chat.isRead : true}
              key={item.bookingId}
              timestamp={chat?.updateAt}
              lastChat={chat?.lastChat}
              isDoctorOwnerLastChat={chat?.isDoctorOwnerLastChat}
            />
          </Link>
        );
      })}
    </ContainerCard>
  );
};

export default ListCustomer;
